import { render, staticRenderFns } from "./ResourceCustomAttributes.vue?vue&type=template&id=60ac7de7&scoped=true&"
import script from "./ResourceCustomAttributes.vue?vue&type=script&lang=ts&"
export * from "./ResourceCustomAttributes.vue?vue&type=script&lang=ts&"
import style0 from "./ResourceCustomAttributes.vue?vue&type=style&index=0&id=60ac7de7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ac7de7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60ac7de7')) {
      api.createRecord('60ac7de7', component.options)
    } else {
      api.reload('60ac7de7', component.options)
    }
    module.hot.accept("./ResourceCustomAttributes.vue?vue&type=template&id=60ac7de7&scoped=true&", function () {
      api.rerender('60ac7de7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dashboard/resource-details/ResourceCustomAttributes.vue"
export default component.exports